/**
 * saffData.js — Saudi Women's Premier League (SAFF Women's PL)
 * 2025–26 season — 8 teams. Al-Nassr defending champions (3×).
 * Data updated to approx. matchday 12 (February 2026).
 */

export const SAFF_SEASON    = '2025–26';
export const SAFF_WORKER_URL = 'https://saff-proxy.footballgirl.workers.dev';

export const SAFF_STANDINGS_FALLBACK = [
  { pos:1, name:'Al-Nassr',        short:'NAS', color:'#F5C518', zone:'champion', p:12, w:10, d:1, l:1, gf:49, ga:10, gd:39, pts:31, form:['W','W','W','D','W'] },
  { pos:2, name:'Al-Qadsiah',      short:'QAD', color:'#004B87', zone:'top',      p:12, w:9,  d:1, l:2, gf:38, ga:14, gd:24, pts:28, form:['W','W','L','W','W'] },
  { pos:3, name:'Al-Hilal',        short:'HIL', color:'#0066CC', zone:'top',      p:12, w:7,  d:2, l:3, gf:26, ga:16, gd:10, pts:23, form:['W','D','W','L','W'] },
  { pos:4, name:'Al-Ahli',         short:'AHL', color:'#006633', zone:'n',        p:12, w:6,  d:1, l:5, gf:24, ga:24, gd:0,  pts:19, form:['L','W','W','L','D'] },
  { pos:5, name:'Al-Ittihad',      short:'ITT', color:'#FFD700', zone:'n',        p:12, w:5,  d:2, l:5, gf:20, ga:22, gd:-2, pts:17, form:['W','L','D','W','L'] },
  { pos:6, name:'Al-Ula',          short:'ULA', color:'#8B4513', zone:'n',        p:12, w:3,  d:2, l:7, gf:16, ga:31, gd:-15,pts:11, form:['L','L','D','W','L'] },
  { pos:7, name:'NEOM',            short:'NEO', color:'#00C8A0', zone:'rel',      p:12, w:2,  d:1, l:9, gf:11, ga:35, gd:-24,pts:7,  form:['L','L','L','W','L'] },
  { pos:8, name:'Eastern Flames',  short:'EFL', color:'#CC0000', zone:'rel',      p:12, w:1,  d:0, l:11,gf:8,  ga:40, gd:-32,pts:3,  form:['L','L','L','L','L'] },
];

export const SAFF_TOP_SCORERS_FALLBACK = [
  { initials:'CL', name:'Clara Luvanga',       club:'Al-Nassr',   goals:12 },
  { initials:'AL', name:'Adriana Leal',         club:'Al-Qadsiah', goals:10 },
  { initials:'IJ', name:'Ibtissam Jraïdi',      club:'Al-Ahli',    goals:6  },
  { initials:'AO', name:'Asisat Oshoala',        club:'Al-Ahli',    goals:6  },
  { initials:'LL', name:'Léa Le Garrec',         club:'Al-Hilal',   goals:5  },
  { initials:'OA', name:'Oriana Altuve',          club:'Al-Ittihad', goals:5  },
];

export const SAFF_FIXTURES_FALLBACK = [
  { date:'2026-01-29', home:'Al-Qadsiah',  homeColor:'#004B87', homeGoals:null, awayGoals:null, away:'Al-Hilal',       awayColor:'#0066CC', status:'NS' },
  { date:'2026-01-29', home:'East. Flames',homeColor:'#CC0000', homeGoals:null, awayGoals:null, away:'Al-Nassr',       awayColor:'#F5C518', status:'NS' },
  { date:'2026-01-29', home:'Al-Ula',      homeColor:'#8B4513', homeGoals:null, awayGoals:null, away:'Al-Ittihad',     awayColor:'#FFD700', status:'NS' },
  { date:'2025-12-06', home:'NEOM',        homeColor:'#00C8A0', homeGoals:0,    awayGoals:2,    away:'Al-Ittihad',     awayColor:'#FFD700', status:'FT' },
  { date:'2025-12-06', home:'Al-Ahli',     homeColor:'#006633', homeGoals:2,    awayGoals:3,    away:'Al-Qadsiah',     awayColor:'#004B87', status:'FT' },
  { date:'2025-12-06', home:'Al-Ula',      homeColor:'#8B4513', homeGoals:2,    awayGoals:5,    away:'Al-Nassr',       awayColor:'#F5C518', status:'FT' },
];

export async function fetchLiveSAFFData() {
  if (!SAFF_WORKER_URL || SAFF_WORKER_URL.includes('footballgirl')) {
    console.info('[SAFF] PROXY_URL not set — using fallback data.');
    return null;
  }
  try {
    const r = await fetch(SAFF_WORKER_URL, { signal: AbortSignal.timeout(6000) });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    const d = await r.json();
    return {
      standings:  d.standings  ?? SAFF_STANDINGS_FALLBACK,
      topScorers: d.topScorers ?? SAFF_TOP_SCORERS_FALLBACK,
      fixtures:   d.fixtures   ?? SAFF_FIXTURES_FALLBACK,
    };
  } catch (e) {
    console.warn('[SAFF] Live fetch failed, using fallback:', e.message);
    return null;
  }
}
